var map = {
	"./decidim/avatar-multiuser.png": 21360,
	"./decidim/brands/google.svg": 93807,
	"./decidim/cc-badge.png": 84378,
	"./decidim/decidim-logo.svg": 13925,
	"./decidim/default-avatar.svg": 66094,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 99282,
	"./decidim/icons.svg": 48785,
	"./decidim/pattern.png": 38494,
	"./decidim/placeholder-card-g.svg": 94419,
	"./decidim/placeholder-card-l.svg": 79192,
	"./decidim/placeholder.jpg": 92879,
	"./decidim/remixicon.symbol.svg": 55383,
	"./decidim/vendor/leaflet/layers-2x.png": 93178,
	"./decidim/vendor/leaflet/layers.png": 36145,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 18712,
	"./decidim/vendor/leaflet/marker-icon.png": 64039,
	"./decidim/vendor/leaflet/marker-shadow.png": 22532,
	"./decidim/vendor/social-share-button/douban.svg": 94342,
	"./decidim/vendor/social-share-button/email.svg": 27427,
	"./decidim/vendor/social-share-button/facebook.svg": 24629,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 19535,
	"./decidim/vendor/social-share-button/hacker_news.svg": 42711,
	"./decidim/vendor/social-share-button/linkedin.svg": 67883,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 24852,
	"./decidim/vendor/social-share-button/pinterest.svg": 88133,
	"./decidim/vendor/social-share-button/reddit.svg": 72725,
	"./decidim/vendor/social-share-button/telegram.svg": 39276,
	"./decidim/vendor/social-share-button/tumblr.svg": 8371,
	"./decidim/vendor/social-share-button/twitter.svg": 1634,
	"./decidim/vendor/social-share-button/vkontakte.svg": 96508,
	"./decidim/vendor/social-share-button/wechat.svg": 62615,
	"./decidim/vendor/social-share-button/whatsapp.svg": 7549,
	"./decidim/vendor/social-share-button/x.svg": 39683,
	"./decidim/vendor/social-share-button/xing.svg": 76805
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55607;